import { makeStyles, Theme } from "@material-ui/core";
import { EnumStatusTransferencia } from "model/enums/enum-status-transferencia";

const retornarCorStatus = (situacao: EnumStatusTransferencia, theme: Theme): string => {
    switch (situacao) {
        case EnumStatusTransferencia.Aceito:
            return theme.palette.success.light;
        case EnumStatusTransferencia.Abortada:
            return theme.palette.error.light;
        case EnumStatusTransferencia.ErroInterno:
            return theme.palette.error.main;
        case EnumStatusTransferencia.Autorizada:
            return theme.palette.success.main;
        case EnumStatusTransferencia.Pendente:
            return theme.palette.warning.light;
        case EnumStatusTransferencia.Rejeitada:
            return theme.palette.error.dark;
        case EnumStatusTransferencia.ProcessandoEstorno:
            return theme.palette.info.main;
        case EnumStatusTransferencia.Estornada:
            return theme.palette.warning.dark;
        case EnumStatusTransferencia.Expirada:
            return theme.palette.warning.main;
        default:
            return theme.palette.info.light;
    }
}

interface StylesProps {
    status: EnumStatusTransferencia;
}

export const useStyles = makeStyles<Theme, StylesProps>((theme) => ({
    container: {
        '& p': {
            fontSize: '12px !important',
            fontWeight: 500,
        }
    },
    valores: {
        [theme.breakpoints.up('lg')]: {
            textAlign: 'right'
        }
    },
    data: {
        [theme.breakpoints.up('lg')]: {
            textAlign: 'center'
        }
    },
    tagColor: {
        background: ({ status }) => retornarCorStatus(status, theme)
    },
    iconsContainer: {
        display: 'flex',
        alignItems: 'flex-end',
        gap: theme.spacing(1),
        borderLeft: `3px solid rgba(0, 0, 0, .1)`,
        [theme.breakpoints.down('md')]: {
            alignItems: 'center'
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        }
    },
    dialogSelecionarMobile: {
        '& button': {
            height: 80
        }
    },
    naoQuebraLinha: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        [theme.breakpoints.down('sm')]: {
            textOverflow: 'unset',
            whiteSpace: 'normal',
            overflow: 'visible',
        }
    }
}))